'use strict';
export default function routes($stateProvider) {
    'ngInject';
    $stateProvider.state('login', {
        redirectTo: '/auth/ares'
    })
        .state('logout', {
        url: '/logout?referrer',
        referrer: 'main',
        template: '',
        controller: function ($state, Auth) {
            'ngInject';
            var referrer = $state.params.referrer || $state.current.referrer || 'main';
            sessionStorage.removeItem('currentCart');
            Auth.logout();
            //$state.go(referrer);
        }
    })
        .state('signup', {
        url: '/registration',
        template: '<signup></signup>',
        //Fix for ES-1439
        controller: function ($state, $location, Auth, $window, $rootScope) {
            $rootScope.loading = true;
            Auth.getSignUpRedirectConfig().then(function (data) {
                $window.open(data.url, '_self');
            });
            Auth.isLoggedIn(function (loggedInUser) {
                if (loggedInUser) {
                    //ES-1439: 1. Log out the user and then 2. redirect this user to registration page.
                    var returnUrl = $location.protocol() + '://' + location.host + '/registration';
                    Auth.logoutAndReturn(returnUrl);
                    return;
                }
            });
        }
    })
        .state('signupConfirmed', {
        url: '/registration/confirmed',
        template: require('./signup/confirmed.html'),
        controller: function ($state, $location, Auth, $scope, $cookies, CreditCardService) {
            $scope.signupError = $cookies.get('signupError') === 'true';
            $scope.credentialUploaded = $cookies.get('credentialUploaded') === 'true';
            $scope.credentialUploadError = $cookies.get('credentialUploadError') === 'true';
            $scope.audience = $cookies.get('audience');
            CreditCardService.getCredential();
            $cookies.remove('credentialUploaded');
            $cookies.remove('credentialUploadError');
            $cookies.remove('audience');
            $cookies.remove('signupError');
        }
    })
        .state('accountInfo', {
        url: '/account/info',
        template: '<settings></settings>',
        authenticate: true
    })
        .state('reorderProducts', {
        url: '/account/orders/reorder-products',
        template: '<order-page-holder><reorder-products-list></reorder-products-list></order-page-holder>',
        authenticate: true
    })
        .state('failedOrders', {
        url: '/account/orders/unprocessed-orders',
        template: '<order-page-holder><failed-orders-list-component></failed-orders-list-component></order-page-holder>',
        authenticate: true
    })
        .state('backOrders', {
        url: '/account/orders/backorders',
        template: '<order-page-holder><backorder-list (redirect-to-pdp)="$ctrl.onRedirectToPdp($event)"></backorder-list></order-page-holder>',
        controllerAs: '$ctrl',
        controller: function ($state, ProductService) {
            'ngInject';
            this.onRedirectToPdp = function (data) {
                var item = data.item;
                var gotoAlternateProduct = data.scrollToAlternatives;
                // what a hack... think of some more useful approach... like providing the gotoAlternateProduct parameter through non url thing...
                ProductService.gotoAlternateProduct = gotoAlternateProduct;
                $state.go('productDetailOld', {
                    productId: item.productId,
                    itemCode: item.itemCode
                });
            };
        },
        authenticate: true
    })
        .state('orderHistory', {
        url: '/account/orders/order-history',
        template: '<order-page-holder><order-history-list></order-history-list></order-page-holder>',
        authenticate: true
    })
        .state('frequentOrders', {
        url: '/account/orders/frequentorders',
        template: '<frequent-orders></frequent-orders>',
        authenticate: true
    })
        .state('orders', {
        url: '/account/orders/:orderId/date/:createDate',
        template: '<order-details></order-details>',
        authenticate: true
    })
        .state('orderInvoice', {
        url: '/account/orders/invoice/:invoiceNumber',
        template: '<invoice-page [invoice-number]="$ctrl.invoiceNumber"></invoice-page>',
        controllerAs: '$ctrl',
        controller: function ($stateParams) {
            'ngInject';
            this.invoiceNumber = $stateParams.invoiceNumber;
        },
        wireframeOptions: { hideHeader: true, hideFooter: true },
        authenticate: true
    })
        .state('manageRx', {
        url: '/account/manage-rx',
        template: require('./manage-rx/manage-rx.html'),
        authenticate: true,
        practitionerOnly: true
    })
        .state('manageCreditCards', {
        url: '/account/manage-credit-cards',
        template: require('./manage-credit-cards/template.html'),
        authenticate: true
    })
        .state('viewBrandAgreements', {
        url: '/account/view-brand-agreements',
        template: require('./view-brand-agreements/template.html'),
        authenticate: true,
        practitionerOnly: true
    })
        .state('editGeneralInfo', {
        url: '/account/edit-general-info',
        template: require('./edit-general-info/template.html'),
        authenticate: true
    })
        .state('manageSalesTax', {
        url: '/account/manage-sales-tax',
        template: require('./manage-sales-tax/template.html'),
        authenticate: true
    })
        .state('manageShippingAddresses', {
        url: '/account/manage-shipping-addresses',
        template: require('./manage-shipping-addresses/template.html'),
        authenticate: true
    })
        .state('manageShippingAddressesAll', {
        url: '/account/manage-shipping-addresses/all',
        template: require('./manage-shipping-addresses/all.template.html'),
        authenticate: true
    })
        .state('manageShippingAddressesDropShip', {
        url: '/account/manage-shipping-addresses/drop-ship',
        template: require('./manage-shipping-addresses/drop-ship.template.html'),
        authenticate: true
    })
        .state('changeEmailPreferences', {
        url: '/account/change-email-preferences',
        template: require('./change-email-preferences/template.html'),
        authenticate: true,
        practitionerOnly: true
    })
        .state('manageCertifications', {
        url: '/account/manage-certifications',
        template: require('./manage-certifications/template.html'),
        authenticate: true,
        practitionerOnly: true
    })
        .state('faqs', {
        url: '/FAQs',
        template: require('./faqs/faqs.html')
    })
        .state('customerService', {
        url: '/CustomerService',
        template: require('./customer-service/customer-service.html')
    })
        .state('homepage', {
        url: '/',
        template: '<main></main>',
    })
        .state('timeoutErrorPage', {
        url: '/timeoutErrorPage',
        template: require('../errors/timeout-error.html')
    })
        .state('testPaymentUi', {
        url: '/account/test-payment-ui',
        template: require('./test-payment-ui/template.html'),
        authenticate: true
    })
        .state('nonceLoading', {
        url: '/nonce-loading',
        template: require('./nonce-loading/nonce-loading.html'),
        wireframeOptions: { hideHeader: true, hideFooter: true },
    });
}
//# sourceMappingURL=account.routes.js.map